import { render, staticRenderFns } from "./documentComponentViewer.vue?vue&type=template&id=e6cff7a0&"
import script from "./documentComponentViewer.vue?vue&type=script&lang=ts&"
export * from "./documentComponentViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports